import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { IconProps } from "./types";

export function LogoutIcon({ size, ...props }: IconProps) {
    return <LogoutRoundedIcon fontSize={size} {...props} />;
}
